import React, { useEffect, useId, useState } from 'react';
import PropTypes from 'prop-types';
import DatePicker, { CalendarContainer } from 'react-datepicker';
import moment from 'moment/moment';
import useEventCallback from '../../../../../utils/hooks/useEventCallback';
import { ReactComponent as CalendarSvg } from '../../../../../assets/icons/calendar.svg';
import { ReactComponent as ClearSvg } from '../../../../../assets/icons/close.svg';

const MonthPicker = ({
  date, onChange, excludeDate, size = 'default', hideClearButton, ...rest
}) => {
  const uniqId = useId();

  const [isCalendarOpen, calendarToggle] = useState(false);

  const closeHandler = useEventCallback((e) => {
    if (!e.target.closest(`[data-id="calendar_${uniqId}"]`) && isCalendarOpen) {
      calendarOpen(false);
    }
  }, [isCalendarOpen]);

  useEffect(() => {
    window.addEventListener('click', closeHandler, true);

    return () => {
      window.removeEventListener('click', closeHandler, true);
    };
  }, []);

  const onChangeMonth = (d) => {
    onChange(moment(d).format('yyyy-MM'));

    calendarOpen(false);
  };
  const calendarOpen = (toggle) => {
    calendarToggle(toggle);
  };

  const calendarContainer = ({ className, children }) => (
    <div className="month_piker_wrapper">
      <CalendarContainer className={className}>
        <div style={{ position: 'relative' }}>{children}</div>
      </CalendarContainer>
    </div>
  );

  return (
    <div data-id={`calendar_${uniqId}`} className={`calendar_wrapper ${size}`}>
      <DatePicker
        customInput={(
          <div className="month_custom_input_wrapper">
            <button
              className={`calendar_custom_input ${isCalendarOpen ? 'active' : ''}`}
              onClickCapture={() => calendarOpen(!isCalendarOpen)}
              type="button"
            >
              <CalendarSvg className="calendar_icon" />

              <div>
                {date
                  ? (
                    <span>
                      {moment(date, 'yyyy-MM').format('MMM yyyy')}
                    </span>
                  )

                  : <span style={{ color: '#949292' }}>mm.yyyy</span>}
              </div>

              <div
                className={`calendar_custom_input_arrow ${isCalendarOpen ? 'open' : ''}`}
              />
            </button>

            {date && !hideClearButton && (
              <ClearSvg
                className="clear_svg"
                onClick={() => onChange('')}
              />
            )}
          </div>
        )}
        selected={date ? new Date(moment(date, 'yyyy-MM')) : null}
        onChange={onChangeMonth}
        calendarContainer={calendarContainer}
        showMonthYearPicker
        open={isCalendarOpen}
        excludeDates={excludeDate ? [new Date(moment(excludeDate, 'yyyy-MM'))] : null}
        dateFormat="yyyy-MM"
        {...rest}
        // popperPlacement="bottom-start"
        // showFullMonthYearPicker
      />
    </div>
  );
};

MonthPicker.propTypes = {
  date: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  excludeDate: PropTypes.string,
  size: PropTypes.oneOf(['default', 'small']),
};

export default MonthPicker;
